import { useCallback } from 'react';

import { makeGroupId } from '@infinex/asset-config';

import { useGasDeposit } from './GasDepositQuoteProvider';

import { useAssetPriceQuery } from '../../api/rates/ratesQueries';
import { CurrencyUnitProvider } from '../unit-switch/CurrencyUnitProvider';

export function GasCurrencyUnitProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { assetSelection } = useGasDeposit();
  const inputAmount = assetSelection.userInputAmount;
  const asset = assetSelection.selectedAssetDetails;

  const { data: priceData } = useAssetPriceQuery(
    asset
      ? makeGroupId({ chain: asset.chain, address: asset.assetAddress })
      : null
  );

  const handleFormValueUpdate = useCallback(
    (value: string) => {
      assetSelection.setUserInputAmount(Number(value));
    },
    [assetSelection]
  );

  return (
    <CurrencyUnitProvider
      onFormValueUpdate={handleFormValueUpdate}
      selectedTokenDecimals={asset?.decimals ?? null}
      inputAmount={inputAmount?.toString() || null}
      selectedTokenUsdRate={priceData?.usd.rate ?? null}
    >
      {children}
    </CurrencyUnitProvider>
  );
}
